




















































import { Component, Vue } from 'vue-property-decorator';
import { get } from 'lodash-es';
import { firebaseApp, firebaseFunctions } from '@/firebase';
import LoadingCover from '@/components/LoadingCover.vue';
import constants from '@/utils/constants';
import api from '@/api';
@Component({
  components: {
    LoadingCover
  }
})
export default class Login extends Vue {
  public error: string = '';
  public form: {
    email: string;
    password: string;
    remember: string;
  } = {
    email: '',
    password: '',
    remember: ''
  };
  isLoading: boolean = false;

  created() {
    if (firebaseApp.auth().currentUser) {
      this.$router.replace('/');
    }
  }

  mounted() {
    // Call Android JS after page components are rendered
    if (window && typeof (window as any).android !== 'undefined') {
      (window as any).android.onLoadFinished()
    }
  }

  // login
  async checkCred() {
    this.error = '';
    this.isLoading = true;
    try {
      localStorage.removeItem('selected-outlet');
      localStorage.removeItem('pos-order-outlet');
      localStorage.removeItem('outletList');
      localStorage.removeItem('outletCodes');
      await firebaseApp
        .auth()
        .signInWithEmailAndPassword(this.form.email, this.form.password)
        .then(credential => {
          return firebaseApp.auth().currentUser!.getIdTokenResult();
        })
        .then(idTokenResult => {
          return firebaseFunctions
            .httpsCallable('refreshAuthUser')({
              loginId: firebaseApp.auth().currentUser!.uid
            })
            .then(async (resp) => {
              if (resp.data.code === constants.STATUS_200_STRING) {
                localStorage.setItem('ID', resp.data.data.id);
                localStorage.setItem('UID', resp.data.data.UID);
                localStorage.setItem('UserName', resp.data.data.UserName);
                localStorage.setItem(
                  'outletCodes',
                  resp.data.data.OutletCodes.join(',')
                );
                this.$store.dispatch('GetUserInfo', {
                  uid: resp.data.data.UID,
                  type: resp.data.data.Type,
                  email: resp.data.data.Email,
                  outlet_codes: resp.data.data.OutletCodes
                });
                if (window && typeof (window as any).webkit !== 'undefined') {
                  (window as any).webkit.messageHandlers.sendUserInfo.postMessage(
                    { userID: resp.data.data.UID, isSign: true }
                  );
                }
                if (window && typeof (window as any).android !== 'undefined') {
                  (window as any).android.pushFirebaseToken(resp.data.data.UID);
                  await api.GetConfiguration(resp.data.data.OutletCodes[0]).then(res => {
                    const resData = get(res, 'data.data');
                    if (resData && resData !== {}) {
                      (window as any).android.pushStoreConfiguration(JSON.stringify(resData));
                    }
                    localStorage.setItem('EDC_MID_MAPPING', JSON.stringify(res.data.data))
                  })
                }
                return resp.data.data.Type;
              }
              return '';
            })
            .then(role => {
              setTimeout(() => {
                window.location.href = '/';
              })
            });
        })
        .catch(err => {
          this.error = 'Invalid Email/Password.';
          this.isLoading = false;
          console.log(err);
        });
    } catch (e) {
      this.error = e.message || constants.SOMETHING_WROING;
      this.isLoading = false;
    }
  }
}
